import React from 'react';
import './DragTheWordContent.scss';
import { DragTheWordQuestionProps } from './DragTheWordQuestion';
import DragTheWordQuestion from './DragTheWordQuestion';

type DragTheWordProps = {
  title: string;
  questions: Array<DragTheWordQuestionProps>;
  index?: number;
  taskDescription?: string;
};

const DragTheWordContent: React.FC<DragTheWordProps> = ({ title, questions, index, taskDescription }) => {
  return (
    <div className="DragTheWord-content">
      <div className="question-type-label">{`${index ? index + '.' : ''} Drag The Word Question`}</div>
      <div>
        <span className="title-label">Title:</span> {title}
      </div>
      <div className="mt-2">
        <span className="title-label">Task Description: </span> {taskDescription}
      </div>
      <div className="drag-the-word-questions mt-2">
        {questions.map((question, index) => (
          <DragTheWordQuestion
            key={`drag-the-word-question-${index}`}
            {...question}
          />
        ))}
      </div>
    </div>
  );
};

export default DragTheWordContent;
